import React, { Fragment } from "react"
import { connect } from "react-redux";
import withAuth from "../hocs/withAuth"
import { fetchRegisterClientIds, fetchFBTokens } from "../store/actions/assignments";

class MainChat extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      token: "",
      isFetchResponse: false,
      name: ""
    }
  }

  componentDidMount() {
    this.props.fetchToken().then((res) => {
      const token = res.token
      if (token !== '') {
        this.setState({
          isFetchResponse: true,
          token: token
        })
      }
    })
  }

  render() {

    const { token, isFetchResponse } = this.state;
    const { currentUser, user } = this.props;
    const url = `${process.env.REACT_APP_CHAT_URL}?token=${token}&userId=${user._id}&role=${user.type}&platform=desktop`;

    return (
      <Fragment>
        { isFetchResponse && user ?
          <iframe
            src={url}
            frameBorder="0"
            style={{overflow:"hidden",height:"calc(100vh - 64px)",width:"100%"}}
            height="100%" width="100%" allow="camera;microphone">
          </iframe>
          : ''}
      </Fragment>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    user: state.currentUser.user,
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchClientIds: () => {
      return dispatch(fetchRegisterClientIds());
    },
    fetchToken: () => {
      return dispatch(fetchFBTokens());
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withAuth(MainChat));



// WEBPACK FOOTER //
// ./src/containers/Chat.js